module.exports = __webpack_public_path__ + "img/mdm-deploy-3.6b699fa3.jpg";